import { env } from "@/env"

import type { TrackingEvent } from "./trackingEvents"

/** Enrich the payload with the correct data based on the event */
export function payloadEnricher(event: keyof TrackingEvent) {
  switch (event) {
    case "PAGEVIEW":
      return {
        event: "virtualPageView",
        page: {
          type: "content",
          title: document.title,
          path: window.location.href,
          environment: env.VITE_HF_CDN_ENV,
          region: "global",
          brand: "arduino",
          language: "EN"
        }
      }
    case "ADD_VARIABLE":
      return { event: "setup_add_variable" }
    case "LINK_DEVICE":
      return { event: "setup_link_device" }
    case "IMPORT_TEMPLATE":
      return { event: "import_template" }
    case "SETUP_DEVICE":
      return { event: "setup_new_device" }
    case "TAG_CREATE":
      return { event: "iot_tag_create" }
    case "API_KEY_CREATE":
      return { event: "iot_cloud_integration", action: "create api key" }
    case "CREATE_SKETCH":
      return { event: "iot_sketch_create" }
    case "SKETCH_INTERACTION":
      return { event: "iot_sketch_interaction" }
    case "TRASH_INTERACTION":
      return { event: "trash_interaction" }
    case "THING_DELETE":
      return { event: "iot_cloud_deletething" }
    case "THING_CREATE":
      return { event: "iot_cloud_creatething" }
    case "TEMPLATE_SELECT":
      return { event: "select_template" }
    case "TEMPLATE_CREATE":
      return { event: "create_template" }
    case "TEMPLATE_GENERATE":
      return { event: "generate_template" }
    case "DASHBOARD_CREATE":
      return { event: "iot_cloud_dashboard", action: "create dashboard" }
    case "TRIGGER_CREATE":
      return { event: "iot_trigger_create" }
    case "BRANDING_SAVE":
      return { event: "save_branding" }
    case "ONBOARDING_DEVICE_CLAIM_SUCCEEDED":
      return {
        event: "onboarding_device_claim_succeeded"
      }
    case "ONBOARDING_DEVICE_CLAIM_FAILED":
      return {
        event: "onboarding_device_claim_failed"
      }
    case "ONBOARDING_NETWORK_CONFIG_COMPLETED":
      return {
        event: "onboarding_network_config_completed"
      }
    case "ONBOARDING_PAUSED":
      return {
        event: "onboarding_paused"
      }
    case "ONBOARDING_RESUMED":
      return {
        event: "onboarding_resumed"
      }
    case "ONBOARDING_ABORTED":
      return {
        event: "onboarding_aborted"
      }
    case "ONBOARDING_DEVICE_STARTED": {
      return {
        event: "onboarding_device_started"
      }
    }
    case "ONBOARDING_BOARD_MIGRATION_TRIGGERED": {
      return {
        event: "onboarding_board_migration_triggered"
      }
    }
    case "SMART_FOLDER_ICON_CLICK":
      return { event: "smart_folder_icon_click" }
    case "SMART_FOLDER_CREATE":
      return { event: "smart_folder_create" }
    case "SMART_FOLDER_DELETE":
      return { event: "smart_folder_delete" }
    case "SMART_FOLDER_EDIT":
      return { event: "smart_folder_edit" }
    default:
      return {}
  }
}
